import React from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Testimonials() {
  const testimonials = [{
    quote: 'Pensé que era imposible entrar sin contactos. A los meses ya estaba embarcado.',
    name: 'Lucas M.'
  }, {
    quote: 'Lo que para mí era un hobby terminó mostrándome una salida que nunca había considerado.',
    name: 'Martina R.'
  }, {
    quote: 'Siempre pensé que navegar era solo un escape de fin de semana… jamás imaginé que podía construir una vida entera alrededor de eso.',
    name: 'Diego T.'
  }, {
    quote: 'Entré desde cero. Hoy cobro en dólares y prácticamente no tengo gastos viviendo a bordo.',
    name: 'Camila S.'
  }];
  return <section className="bg-navy-900 py-24 border-t border-navy-800" data-id="element-183">
      <div className="container mx-auto px-4" data-id="element-184">
        <FadeIn data-id="element-185">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-white mb-16" data-id="element-186">
            Lo que dicen otros alumnos
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-187">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-188">
              <div className="bg-navy-800 rounded-2xl p-8 border border-navy-700 relative" data-id="element-189">
                <div className="flex gap-1 mb-4" data-id="element-190">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-500 text-gold-500" data-id="element-191" />)}
                </div>
                <p className="text-xl text-gray-300 italic mb-6" data-id="element-192">
                  "{testimonial.quote}"
                </p>
                <div className="font-bold text-white" data-id="element-193">— {testimonial.name}</div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}